/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { AccommodationTaxState } from '../state/AccommodationTaxState'
import { ReservationState } from '../state/ReservationState'
import AccommodationInvoiceEvent from '../../event/AccommodationInvoiceEvent'

class AccommodationTaxStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AccommodationTaxState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccommodationInvoiceEvent.createStart:
        // 初回ロード時
        return state.buildBy(new ReservationState().mergeModel(payload))

      case AccommodationInvoiceEvent.onEditAccommodationTax:
        return state.updateBy(payload.reservation, payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new AccommodationTaxStore()
